import { render } from "./BreadCrumps.vue?vue&type=template&id=789ce21e"
import script from "./BreadCrumps.vue?vue&type=script&lang=js"
export * from "./BreadCrumps.vue?vue&type=script&lang=js"

import "./BreadCrumps.vue?vue&type=style&index=0&id=789ce21e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__